var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircleCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hicon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Close Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.87868 10.97L14.1213 15.2126M9.87868 15.2126L14.1213 10.97M22 12.8486C22 18.3715 17.5228 22.8486 12 22.8486C6.47715 22.8486 2 18.3715 2 12.8486C2 7.32579 6.47715 2.84863 12 2.84863C17.5228 2.84863 22 7.32579 22 12.8486Z",
    stroke: "#A4A8AE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCross);
export default __webpack_public_path__ + "static/media/circle-cross.bf444a1d63864d59776861fa2791d27b.svg";
export { ForwardRef as ReactComponent };